interface LoadingTextProps {
  label: string;
}

export default function LoadingText({ label }: LoadingTextProps) {
  return <p style={{ paddingLeft: '3rem' }}>Loading {label}...</p>;
}
